"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const standard_resolutions_1 = __importDefault(require("../../utilites/standard-resolutions"));
const cast_1 = require("../../utilites/cast");
class Resolution {
    constructor() {
        this.w = 0;
        this.h = 0;
    }
    static from(object) {
        return cast_1.castToType(object, Resolution);
    }
    toString() {
        var _a;
        const std = standard_resolutions_1.default(this);
        return ((_a = std) === null || _a === void 0 ? void 0 : _a.abr) || `${this.w}px x ${this.h}px`;
    }
}
exports.Resolution = Resolution;
